import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { analyticsService } from '@/services/analytics/analyticsService';

/**
 * Logs ON_BOARDING / ON_BOARDING once per auth page — mirrors Flutter OnboardingBloc, whose
 * constructor logs the event. The login, sign-up and MFA pages provide that bloc lazily and
 * only WebOnboardingPage reads it, which those pages build on desktop only, so the event
 * fires when a page first shows on a non-mobile width. Each route counts as a new page.
 */
export function useOnboardingAnalytics(): void {
  const { pathname } = useLocation();
  const isMobile = useIsMobile();
  const loggedForPath = useRef<string | null>(null);

  useEffect(() => {
    if (isMobile || loggedForPath.current === pathname) return;
    loggedForPath.current = pathname;
    void analyticsService.logEvent('ON_BOARDING', 'ON_BOARDING');
  }, [pathname, isMobile]);
}
